import gql from "graphql-tag";

export const updateBonusProgramLevelMutation = gql`
  mutation updateBonusProgramLevel($id: ID!, $threshold: Int!, $benefits: [LevelBenefitInput!]!) {
    updateBonusProgramLevel(id: $id, threshold: $threshold, benefits: $benefits) {
      id
    }
  }
`;
